import React from "react";

// MUI
import { Chip } from "@mui/material";

// Colours
import { terracotta } from "Constants/ColourConstants";

// React DnD
import { useDrag } from "react-dnd";

export const ItemTypes = {
  VARIABLE: "variable",
};

export default function DraggableVariable({ name, label }) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: ItemTypes.VARIABLE,
    item: { name },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <Chip
      ref={drag}
      label={label}
      variant="outlined"
      sx={{
        opacity: isDragging ? 0.5 : 1,
        cursor: "grab",
        padding: "2px 6px",
        margin: "0 4px",
        borderRadius: 30,
        fontSize: "14px",
        color: terracotta,
        border: `1px solid ${terracotta}`,
      }}
    />
  );
}
